<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      Logs
    </portal>
    <template v-if="data !== null">
      <card title="Filter" cols="12">
        <hm-input-select v-model="type"
                         label="Interface Type"
                         cols="12 6@tablet 3@desktop 3@hd"
                         name="type">
          <option :value="null"></option>
          <option v-for="it in interfaceTypes" :value="it">{{ getInterfaceName(it) }}</option>
        </hm-input-select>
        <hm-input-select v-model="status"
                         label="Status"
                         cols="12 6@tablet 3@desktop 3@hd"
                         name="status"
                         enum-name="MessageStatus" >
          <option :value="null"></option>
        </hm-input-select>
        <hm-input-select v-model="messageType"
                         label="Message Type"
                         cols="12 6@tablet 3@desktop 3@hd"
                         name="messageType">
          <option :value="null"></option>
          <option v-for="it in data.messageType" :value="it">{{ it }}</option>
        </hm-input-select>
      </card>
      <card title="Logs" cols="12">
        <hm-card-inner :full-size="true">
          <paginated-table id="logs"
                           :rows="filteredRows"
                           :hover="true"
                           :items-per-page="15"
                           columns="6"
                           min-width="600px">
            <template slot="table-head">
              <div class="hm-table__th">Date/Time</div>
              <div class="hm-table__th">Interface</div>
              <div class="hm-table__th">Message Type</div>
              <div class="hm-table__th">Status</div>
              <div class="hm-table__th">Detail</div>
              <div class="hm-table__th">Length</div>
            </template>
            <template v-slot:default="slotProps">
              <template v-for="row in slotProps.currentPage">
                <div :class="[{'color--red text--bold': ['Error'].includes(row.status)}]" class="hm-table__td" @click="open(row.s3FileKey)">{{ row.dateTime | toDateTime }}</div>
                <div :class="[{'color--red text--bold': ['Error'].includes(row.status)}]" class="hm-table__td" @click="open(row.s3FileKey)">{{ getInterfaceName(row.type) }}</div>
                <div :class="[{'color--red text--bold': ['Error'].includes(row.status)}]" class="hm-table__td" @click="open(row.s3FileKey)">{{ row.messageType }}</div>
                <div :class="[{'color--red text--bold': ['Error'].includes(row.status)}]" class="hm-table__td" @click="open(row.s3FileKey)">{{ $t(`MessageStatus.${row.status}`) }}</div>
                <div :class="[{'color--red text--bold': ['Error'].includes(row.status)}]" class="hm-table__td" @click="open(row.s3FileKey)">{{ row.detail }}</div>
                <div :class="[{'color--red text--bold': ['Error'].includes(row.status)}]" class="hm-table__td" @click="open(row.s3FileKey)">{{ row.length }}</div>
              </template>
            </template>
          </paginated-table>
        </hm-card-inner>
      </card>
    </template>
    <hm-floating-buttons>
      <hm-floating-button :throttle="2500"
                          icon="refresh"
                          color="green"
                          label="Refresh"
                          @click="reloadData" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import { isEmpty, isNil, filter, map, uniq } from 'lodash';
import HmFloatingButtons from '../../../lib/inputs/HmFloatingButtons';
import HmFloatingButton from '../../../lib/inputs/HmFloatingButton';

export default {
  name: 'PageKiosk',
  components: { HmFloatingButton, HmFloatingButtons },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      type: null,
      status: null,
      messageType: null,
      data: null,
    };
  },

  computed: {
    interfaceTypes: function () {
      if (isEmpty(this.data) || isEmpty(this.data.entries)) {
        return this.hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') ? this.enums.InterfaceType : [];
      } else {
        return uniq(map(this.data.entries, 'type'));
      }
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    filteredRows: function () {
      if (isNil(this.data) || isNil(this.data.entries)) return [];

      return filter(
        this.data.entries,
        (it) => {
          if (!isEmpty(this.type) && this.type !== it.type) return false;
          if (!isEmpty(this.status) && this.status !== it.status) return false;
          if (!isEmpty(this.messageType) && this.messageType !== it.messageType) return false;
          return true;
        },
      ).slice(0, 200);
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isEmpty,
    reloadData() {
      this.loadData()
        .then(() => {
          this.showSuccessMessage();
        });
    },
    loadData() {
      return this.axios.get(this.serviceUrls.interfaces.logs.list(this))
        .then((response) => {
          this.data = response.data.data;
        });
    },
    open(s3FileKey) {
      this.axios.get(this.serviceUrls.interfaces.logs.content(this), { params: { s3FileKey: s3FileKey } })
        .then((response) => {
          const content = response.data.data;

          const windowUrl = URL.createObjectURL(
            new Blob([content], { type: 'text/plain;charset=utf-8' }),
          );

          window.open(windowUrl, '_blank');
        });
    },
    getInterfaceName(item) {
      const key = `InterfaceType.${item}`;
      const t = this.$t(`InterfaceType.${item}`);

      return t === key ? item : t;
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageLogs.vue